// Minimal className joiner (clsx-alike) so the kit doesn't need a dependency.
export function cx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ')
}
